const dateFmt = new Intl.DateTimeFormat('uk-UA', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export function formatDate(d: Date | string | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return '—';
  return dateFmt.format(date);
}

// Short numeric date + time, e.g. «28.06.2026, 14:30». Used for payments where
// the exact moment matters (occurred_at carries time).
const dateTimeFmt = new Intl.DateTimeFormat('uk-UA', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDateTime(d: Date | string | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return '—';
  return dateTimeFmt.format(date);
}

/** Returns Ukrainian word form for days count: 1 день / 2-4 дні / 0,5-21+ днів. */
export function daysWord(n: number): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs >= 11 && abs <= 14) return 'днів';
  if (last === 1) return 'день';
  if (last >= 2 && last <= 4) return 'дні';
  return 'днів';
}

/** Generic Ukrainian plural: pick form based on count.
 *  Example: pluralUa(n, 'матеріал', 'матеріали', 'матеріалів') */
export function pluralUa(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs >= 11 && abs <= 14) return many;
  if (last === 1) return one;
  if (last >= 2 && last <= 4) return few;
  return many;
}

/** Format duration in seconds as `m:ss` (e.g. 517 → "8:37", 720 → "12:00"). */
export function durationLabel(sec: number | null | undefined): string {
  if (!sec) return '';
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function daysUntil(d: Date | string | null | undefined, now: Date = new Date()): number {
  if (!d) return 0;
  const date = typeof d === 'string' ? new Date(d) : d;
  return Math.max(0, Math.ceil((date.getTime() - now.getTime()) / 86_400_000));
}
